import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware, createStore } from "redux";
import { persistStore } from "redux-persist";
import thunk from "redux-thunk";
import { apiMiddleware } from "../middleware/api";
import rootReducer from "../reducers/index";

const middlewares = [thunk, apiMiddleware];
// const { logger } = require('redux-logger');

if (process.env.NODE_ENV === "development") {
  // middlewares.push(logger);
}

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middlewares))
);
const persistor = persistStore(store);

// Expose store for E2E testing (allows dispatching auth actions)
if (typeof window !== "undefined") {
  window.__REDUX_STORE__ = store;
}

export { store, persistor };
